import { setSelectedAction } from '@modules/Filters';

import { KEY } from './constants';

export const setSelected = (values) => setSelectedAction(KEY, values);
